<!-- <p>asset-actions works!</p> -->
<app-dialog-header headerIcon="content_paste" headerText="Asset Actions"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="adjusting-width">
    <div class="top alignRow">
        <span style="font-size: larger; font-weight: bolder;">{{ Asset.Name }} - {{ Asset.Description }} Actions</span>        
    </div>
    <div class="top alignRow">
        <span class="toolbar-spacer"></span>
        <div class="alignRow">
            <span>My Actions Only</span>
            <mat-checkbox color="primary" [checked]="myActionsOnly" (change)="toggleCheckbox($event, false)"></mat-checkbox>
        </div>
        <div class="alignRow">
            <span>Overdue Only</span>
            <mat-checkbox color="primary" [checked]="overdueOnly" (change)="toggleCheckbox($event, true)"></mat-checkbox>
        </div>
    </div>
    <div *ngIf="Actions && Actions.length > 0" style="padding: 1em; width: 100%; max-height: 75vh; overflow-y: auto;">
        <div class=" content-body">
            <ejs-accordion>
                <e-accordionitems>
                    <e-accordionitem *ngFor="let action of filteredActions" [expanded]="false">
                        <ng-template #header>
                            <div class="alignRow" style="display: flex; width: 100%; border-radius: var(--default-border-radius); padding: 0.5em;"
                                [ngStyle]="{'border': checkIfOverdue(action) ? '2px solid var(--action-bg-color)' : ''}">
                                <span><b>{{ getActionTypeFromValue(action.ActionType) }}</b></span>
                                <div class="toolbar-spacer"></div>
                                <span
                                    *ngIf="action.AssignedToUserSub && action.TargetCompletionTimestamp != undefined">For
                                    <b>{{
                                        action.AssignedToUserSub }}</b> to complete on <b>{{
                                        convertEpochNoTime(action.TargetCompletionTimestamp) }}</b></span>
                                <span style="margin-left: 0.5em;"  class="alignRow app-icon--goto" matTooltip="Go to Action"
                                    (click)="goToAction($event, action)">
                                    <mat-icon/>
                                </span>
                            </div>
                        </ng-template>
                        <ng-template #content>
                            <span>{{ action.Details }}</span>
                        </ng-template>
                    </e-accordionitem>
                </e-accordionitems>
            </ejs-accordion>
        </div>
    </div>
</div>